import React, { Component } from "react";
class Payment3DDecline extends Component {
    render() {
        return (<div className="container">
            <h1>Decline</h1>
        </div>);
    }
}
export default Payment3DDecline;